import React, { useEffect, useState, useCallback } from 'react';
import { Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
import {
  siteRegionListFetchData,
  regionListFetchData,
  updateSiteRegionData,
  dealFunderListWithRegionsFetchData,
  addSiteRegionData,
} from '../../actions/regionActions';
import NoRowExistsRow from '../../components/common/noRowExistsRow';

const StoreRegionPage = () => {
  const dispatch = useDispatch();
  const siteRegionList = useSelector((state) => state.siteRegionList);
  const regionList = useSelector((state) => state.regionList);
  const dealFunderList = useSelector((state) => state.dealFunderList);
  const isLoading = useSelector(
    (state) => state.siteRegionListIsLoading ?? true,
  );
  const siteRegionUpdateSuccess = useSelector(
    (state) => state.siteRegionUpdateSuccess,
  );
  const siteRegionAddSuccess = useSelector(
    (state) => state.siteRegionAddSuccess,
  );

  const [emptyRowString] = useState('No Data Exist');
  const [isFormValid, setIsFormValid] = useState(false);
  const [editRowId, setEditRowId] = useState();
  const [editSiteId, setEditSiteId] = useState();
  const [funderId, setFunderId] = useState();
  const [filterRegionId, setFilterRegionId] = useState(0);
  const [isOverride, setIsOverride] = useState(false);
  const [selectedRegionId, setSelectedRegionId] = useState(null);

  useEffect(() => {
    dispatch(siteRegionListFetchData());
    dispatch(regionListFetchData());
    dispatch(dealFunderListWithRegionsFetchData());
  }, [dispatch]);

  useEffect(() => {
    if (siteRegionUpdateSuccess || siteRegionAddSuccess) {
      setEditRowId(0);
      setIsOverride(false);
    }
  }, [siteRegionUpdateSuccess, siteRegionAddSuccess]);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (name === 'selectedRegionId') {
      setSelectedRegionId(value);
    }
  };

  const handleDealFunderChange = (event) => {
    setFunderId(event.target.value);
    setFilterRegionId(0);
    dispatch(siteRegionListFetchData(event.target.value));
    dispatch(regionListFetchData(event.target.value));
  };

  const handleDealFunderRegionChange = (event) => {
    console.log('handleDealFunderRegionChange', event.target.value, funderId);
    setFilterRegionId(event.target.value);
    dispatch(siteRegionListFetchData(funderId, event.target.value));
  };

  const handleEditSiteRegion = (id, editSiteId, isOverride) => {
    setEditRowId(id);
    setEditSiteId(editSiteId);
    setIsOverride(isOverride);
    setSelectedRegionId(null);
  };

  const handleSaveSiteRegion = (id, siteId) => {
    if (!selectedRegionId) {
      return;
    }
    if (editRowId > 0) {
      if (funderId) {
        if (isOverride) {
          dispatch(updateSiteRegionData(id, selectedRegionId, funderId));
        } else {
          dispatch(addSiteRegionData(siteId, selectedRegionId, funderId));
        }
      } else {
        dispatch(updateSiteRegionData(id, selectedRegionId, funderId));
      }
    }
    if (editRowId === 0) {
      dispatch(addSiteRegionData(siteId, selectedRegionId, funderId));
    }
  };

  const getRowKey = (siteRegion) => {
    return siteRegion.siteId + '-' + siteRegion.id + '-' + siteRegion.name;
  };

  const renderSiteRegionRow = useCallback(
    (siteRegion) => {
      if (editRowId === siteRegion.id && editSiteId === siteRegion.siteId) {
        return (
          <div key={getRowKey(siteRegion)}>
            <Row>
              <Col md='6' className='white-border'>
                {siteRegion.id}-{siteRegion.siteId}-{siteRegion.siteName}
              </Col>
              <Col md='5' className='white-border'>
                <Input
                  type='select'
                  name='selectedRegionId'
                  required
                  onChange={handleInputChange}
                  value={selectedRegionId || siteRegion.regionId}
                >
                  <option value='0' disabled>
                    Region
                  </option>
                  {regionList.map((reg) => (
                    <option key={siteRegion.id + '-' + reg.id} value={reg.id}>
                      {reg.regionName}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col md='1' className='white-border'>
                <button
                  className='btn btn-xs btn-primary'
                  onClick={() =>
                    handleSaveSiteRegion(siteRegion.id, siteRegion.siteId)
                  }
                  disabled={siteRegion.regionType === 1}
                >
                  Save
                </button>
              </Col>
            </Row>
          </div>
        );
      } else {
        return (
          <Row className='campaign-row' key={getRowKey(siteRegion)}>
            <Col md='6' className='white-border'>
              {siteRegion.id}-{siteRegion.siteId}-{siteRegion.siteName}
            </Col>
            <Col md='5' className='white-border'>
              <span className={siteRegion.isOverride ? 'bold' : ''}>
                {siteRegion.regionName}
              </span>
            </Col>
            <Col md='1' className='white-border'>
              <button
                className='btn btn-xs btn-primary'
                onClick={() =>
                  handleEditSiteRegion(
                    siteRegion.id,
                    siteRegion.siteId,
                    siteRegion.isOverride,
                  )
                }
                disabled={siteRegion.regionType === 1}
              >
                Edit
              </button>
            </Col>
          </Row>
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editRowId, editSiteId, isOverride, selectedRegionId, regionList],
  );

  const siteRegionListRows =
    !isLoading && siteRegionList && siteRegionList.length > 0 ? (
      siteRegionList.map((siteRegion) => renderSiteRegionRow(siteRegion))
    ) : (
      <NoRowExistsRow emptyRowText={emptyRowString} />
    );

  return (
    <div>
      <h4>Manage Store Region Mapping</h4>
      <Form className='d-flex align-items-center flex-nowrap w-100'>
        <FormGroup className='d-flex align-items-center me-3 flex-nowrap'>
          <Label for='dealFunder' className='mb-0 me-2 text-nowrap'>
            Deal Funder
          </Label>
          <Input
            type='select'
            name='dealFunder'
            required
            onChange={handleDealFunderChange}
            value={funderId}
          >
            <option value=''>- All -</option>
            {dealFunderList.map((fudner) => (
              <option key={fudner.id} value={fudner.id}>
                {fudner.name}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup className='d-flex align-items-center me-3 flex-nowrap'>
          <Label for='dealFunderRegion' className='mb-0 me-2 text-nowrap'>
            Region
          </Label>
          <Input
            type='select'
            name='dealFunderRegion'
            required
            onChange={handleDealFunderRegionChange}
            value={filterRegionId}
          >
            <option value='0'>- All -</option>
            {regionList.map((reg) => (
              <option key={reg.id} value={reg.id}>
                {reg.regionName}
              </option>
            ))}
          </Input>
        </FormGroup>
      </Form>
      <h6 className='mt-2'>Stores</h6>
      {isLoading ? (
        <BeatLoader color={'#004C5F'} loading={isLoading} />
      ) : (
        <div>
          <Row>
            <Col md='6' className='column-header white-border'>
              Store
            </Col>
            <Col md='5' className='column-header white-border'>
              Region
            </Col>
            <Col md='1' className='column-header white-border'></Col>
          </Row>
          {siteRegionListRows}
        </div>
      )}
    </div>
  );
};

export default StoreRegionPage;
